"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-d-ario": {
    "eeff110f": [{
      "hkey": "8fa8f8ce",
      "slug": "castel-d-ario",
      "name": "Castel d'Ario",
      "primary": true,
      "skipSearch": false
    }],
    "centro-urbano": [{
      "hkey": "8fa8f8ce",
      "slug": "castel-d-ario",
      "name": "Castel d'Ario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;